import {Injectable} from '@angular/core';
import {SidenavFilter, SidenavFilterChain, SidenavItem} from '@mctic/ng-core';
import {Observable, of} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {ConfiguracaoAnoBaseService, SecurityService} from 'src/app/service';
import {SigplaniModuloEnum} from '../../shared/enum/sigplani-modulo.enum';
import {SidenavItemEnum} from '../sidenav-item.enum';


@Injectable({
  providedIn: 'root'
})
export class InstituicaoSidenavFilter implements SidenavFilter {

  readonly mappings: string[];

  readonly skipping: string[] = [
    SidenavItemEnum.PaginaInicial,
    SidenavItemEnum.SelecionaEntidade,
    SidenavItemEnum.Rda,
    SidenavItemEnum.ProjetoConveniado
  ];

  constructor(private readonly securityService: SecurityService,
              private readonly configuracaoAnoBaseService: ConfiguracaoAnoBaseService) {
  }

  canActivate(_: SidenavItem): Observable<boolean> {
    return of(this.securityService.isModuloAtivo(SigplaniModuloEnum.RDA) &&
      this.securityService.isInstituicaoAutenticada());
  }

  doFilter(sidenavItem: SidenavItem, chain: SidenavFilterChain): Observable<boolean> {
    const idAnoBase = this.securityService.usuarioSessao.anoBase.id;
    return this.configuracaoAnoBaseService.obterConfiguracaoAnoBasePorIdAnoBase(idAnoBase).pipe(
      map(configuracao => !this.configuracaoAnoBaseService.isPeriodoPreenchimentoRda(configuracao.configuracaoAnoBase)),
      switchMap(ativo => chain.nextOrComplete(sidenavItem, ativo))
    );
  }

}
